export default "__VITE_ASSET__DiAfk_$p__"